<template>
    <div class="form-check form-check-inline">
        <input
            class="form-check-input"
            :type="radio ? 'radio' : 'checkbox'"
            :readonly="readonly"
            :required="required"
            :disabled="disabled"
            :id="id"
            :name="name"
            :value="checkValue"
            :checked="value == checkValue"
            v-on:change="$emit('input', radio ? $event.target.value : $event.target.checked)"
        />

        <label :class="labelClass" :for="id" v-if="label || $slots.label">
            <slot name="label">
                {{ label }}
            </slot>
        </label>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            value: null,
            checkValue: null,
            placeholder: String,
            required: Boolean,
            readonly: Boolean,
            disabled: Boolean,
            radio: Boolean,
            name: String,
            label: String,
            labelClass: {
                default: 'text-dark small form-check-label',
                type: String
            }
        },
        data() {
            return {
                id: `check-input-${this.uid}`
            };
        }
    });
</script>
